import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 72 72"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M55.83 37.36v22.638c0 1.104-.887 2.002-1.978 2.002H19.148c-1.09 0-1.977-.898-1.977-2.002V37.361c0-1.104.887-2.002 1.977-2.002s1.978.898 1.978 2.002v20.635h30.756V37.361c0-1.104.887-2.002 1.977-2.002s1.978.898 1.978 2.002h-.007Zm5.584-2.949L37.89 10.599c-.79-.799-1.985-.799-2.774 0l-23.53 23.812a1.997 1.997 0 0 0-.587 1.4c0 .517.21 1.02.587 1.408.398.404.888.602 1.384.602.496 0 .992-.198 1.383-.602l22.14-22.41 22.138 22.41c.378.382.874.595 1.391.595.601 0 1.097-.22 1.412-.623.761-.8.755-1.988-.028-2.78h.007Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "home"}) } }